export const SCAN_SCANNED_INPUT = 'SCAN_SCANNED_INPUT';
export const FIND_RECENT_LIMBO_SHIPMENTS = 'FIND_RECENT_LIMBO_SHIPMENTS';
export const MANUAL_RESOLVE_LIMBO_SHIPMENT = 'MANUAL_RESOLVE_LIMBO_SHIPMENT';
export const SCAN_PACKED_INPUT = 'SCAN_PACKED_INPUT';
export const GET_DASHBOARD_INFO = 'GET_DASHBOARD_INFO';
export const STORE_DASHBOARD_INFO = 'STORE_DASHBOARD_INFO';
export const STORE_SCAN_RESPONSE = 'STORE_SCAN_RESPONSE';
export const CLEAR_SCAN_RESPONSE = 'CLEAR_SCAN_RESPONSE';
export const STORE_PACKED_RESPONSE = 'STORE_PACKED_RESPONSE';
export const STORE_LIMBO_SHIPMENTS = 'STORE_LIMBO_SHIPMENTS';
export const HANDLE_RESOLVED_SHIPMENT = 'HANDLE_RESOLVED_SHIPMENT';
export const CLEAR_RESOLVE_LIMBO_SHIPMENT_RESPONSE_MESSAGE = 'CLEAR_RESOLVE_LIMBO_SHIPMENT_RESPONSE_MESSAGE'
export const CLEAR_PACKED_RESPONSE = 'CLEAR_PACKED_RESPONSE';
export const STORE_SCANNED_BARCODES = 'STORE_SCANNED_BARCODES';
export const UPDATE_SCANNED_BARCODE = 'UPDATE_SCANNED_BARCODE';
export const STORE_PACKED_BARCODES = 'STORE_PACKED_BARCODES';
export const UPDATE_PACKED_BARCODE = 'UPDATE_PACKED_BARCODE';
export const STORE_PENDING_PACKED_BARCODES = 'STORE_PENDING_PACKED_BARCODES';
export const UPDATE_PENDING_PACKED_BARCODE = 'UPDATE_PENDING_PACKED_BARCODE';
export const STORE_TOTAL_BARCODES = 'STORE_TOTAL_BARCODES';
export const MANUAL_PACK = 'MANUAL_PACK';
export const MANUAL_VOID = 'MANUAL_VOID';
export const SET_REFRESH = 'SET_REFRESH'
export const DASHBOARD_REFRESH = 'DASHBOARD_REFRESH'

export const LIST_SHIPPED_SHIPMENT_IN_QUEUE = 'LIST_SHIPPED_SHIPMENT_IN_QUEUE'
export const FETCH_SHIPPED_SHIPMENT = 'FETCH_SHIPPED_SHIPMENT'
export const ADD_SHIPPED_SHIPMENT_TO_QUEUE = 'ADD_SHIPPED_SHIPMENT_TO_QUEUE'
export const UPDATE_SHIPPED_SHIPMENT_IN_QUEUE = 'UPDATE_SHIPPED_SHIPMENT_IN_QUEUE'
export const MANUAL_CONFIRM_SHIPPED_SHIPMENT = 'MANUAL_CONFIRM_SHIPPED_SHIPMENT'
export const RESOLVE_SHIPPED_SHIPMENT = 'RESOLVE_SHIPPED_SHIPMENT'
export const STORE_SHIPPED_SHIPMENT_QUEUE = 'STORE_SHIPPED_SHIPMENT_QUEUE'
export const IMPORT_SHIPPED_SHIPMENT_TO_QUEUE = 'IMPORT_SHIPPED_SHIPMENT_TO_QUEUE'
export const SET_IMPORT_LOADING = 'SET_IMPORT_LOADING'
